import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Auth } from 'aws-amplify'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-css-transition'
import TransitionStyles from '../lib/transitionStyles'
import { createBooking } from '../actions/bookingActions'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import LoginForm from './LoginForm'
import Spinner from '../components/Spinner'
import SignupForm from '../components/signup/SignupForm'
import SignedOutBlock from '../components/bookingHome/SignedOutBlock'
import Modal from '../components/Modal'
import AuthenticatedAPI from '../lib/authenticatedAPI'
import { isHourly } from '../lib/utils'

class BookingSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      user: null,
      userInfo: {},
      // booking: props.booking,
      currentModal: null
    }
    this.afterUserSignup = this.afterUserSignup.bind(this)
    this.openLoginModal = this.openLoginModal.bind(this)
  }

  componentWillMount() {
    window.scrollTo(0, 0); // TODO avoid duplication on all pages

    const { booking } = this.props
    if (booking && booking.people && booking.people[0]) {
      const { firstName, lastName } = booking.people[0]
      const userInfo = {
        firstName,
        lastName
      }
      this.setState({ userInfo })
    }
  }

  async componentDidMount() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      this.setState({ user })
    } catch (e) {
      console.log(e)
    }
    this.setState({ isLoading: false })
  }

  afterUserSignup() {
    const { props } = this
    props.history.push('/bookings/payment')
  }

  openLoginModal() {
    const { props } = this
    const { booking } = props
    const closeAction = () => { this.setState({ currentModal: null })}

    const afterLoginAction = async () => {

      const userInfo = await AuthenticatedAPI.get('cphill', '/users')
      const bookersOwnMembership = userInfo.memberships.find(m => m.isBookersOwn && !m.status)
      const { id, ageCategory, type } = bookersOwnMembership

      if (!booking.bookerNotAttending) {
        booking.people[0] = {
          ...booking.people[0],
          userId: userInfo.id,
          membership: bookersOwnMembership,
          membershipId: id,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          ageCategory,
          passType: !isHourly(type) ? type : booking.people[0].passType
        }
      }

      props.createBooking(booking)

      props.history.push('/bookings/payment')
    }

    this.setState({
      currentModal: (
        <Modal closeAction={closeAction}>
          <LoginForm afterLoginAction={afterLoginAction} />
        </Modal>
      )
    })
  }  

  renderForm() {
    const { state } = this

    return (
      <>
        <h5 className="uppercase text-sky tracking-wide-2xl">
          <FormattedMessage id="booking.signup.category" defaultMessage="New booking" />
        </h5>

        <h1 className="text-4xl border-b pb-4">
          <FormattedMessage id="booking.signup.header" defaultMessage="Become a member" />
        </h1>

        <SignedOutBlock openLoginModal={this.openLoginModal} />

        <h5 className="uppercase text-grey tracking-wide-2xl mt-8">
          <FormattedMessage id="booking.signup.newMember.category" defaultMessage="New member" />
        </h5>
        
        <h2>
          <FormattedMessage id="booking.signup.newMember.header" defaultMessage="Sign up here" />
        </h2>
        <div className="text-sm mt-4 text-sky font-normal">
          <p>
            <FormattedMessage
              id="booking.signup.descriptionLn1"
              defaultMessage="We need to be able to contact you regarding your booking."
            />
            <br />
            <FormattedMessage
              id="booking.signup.descriptionLn2"
              defaultMessage="This login is the same for your SKI365 membership"
            />
          </p>
        </div>

                
        <SignupForm afterUserSignup={this.afterUserSignup} userInfo={state.userInfo} backAction={() => { window.history.back() }} />
      </>

    )
  }

  render() {
    const { booking } = this.props
    const { isLoading, user, currentModal } = this.state

    if (isLoading) {
      return (
        <Spinner />
      )
    }

    return (
      <>
        {currentModal}

        <BookingBreadcrumb booking={booking} step={4} />
        <div className="container mx-auto">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            <CSSTransition {...TransitionStyles} transitionAppear active>
              {user === null
                ? this.renderForm()
                : (
                  <LoginForm />
                )}
            </CSSTransition>
          </div>
        </div>
      </>
    );
  }
}

BookingSignup.propTypes = {
  booking: PropTypes.shape({
    booking: PropTypes.object
  })
}

BookingSignup.defaultProps = {
  booking: {}
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingSignup))